import { createFileRoute, notFound } from "@tanstack/react-router";
import shopStyles from "../styles/shop.css?url";
import { DemoOrderPage } from "../components/shop/demo-order-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadOrderPage } from "../server/shop";

/**
 * An order from a demo's Stripe test checkout (/merch/orders/demo?session=…), where Checkout
 * returns. The buyer's browser asks for it with the session; the page itself holds nothing about it.
 */
export const Route = createFileRoute("/merch/orders/demo")({
  loader: async () => {
    const page = await loadOrderPage({ data: "order" });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = withStylesheet(
      creatorPageHead(shell, {
        pathname: "/merch/orders/demo",
        title: `Test order | ${loaderData.creatorName}`,
        description: shell.creator.description,
        noindex: true,
      }),
      shopStyles,
    );
    return { ...head, meta: [...(head.meta ?? []), { name: "referrer", content: "no-referrer" }] };
  },
  component: DemoOrder,
});

function DemoOrder() {
  return <DemoOrderPage creatorId={Route.useLoaderData().creatorId} />;
}
